import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/ready',
    name: 'introView',
    component: () => import('@/views/ReadyView.vue')
  },
  {
    path: '/main',
    name: 'HomeView',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/',
    redirect: { name: 'HomeView' },
    component: () => import('@/views/PageView.vue'),
    children: [
      {
        path: 'service',
        name: '사업소개',
        meta: { 
          title: '사업소개 | 디코나이' ,
          pageTitle: 'BUSINESS',
          pageSubTitle: '새로운 가치를 만들어갑니다.',
          backgroundImage: new URL('@/assets/img/sub_top1.jpg', import.meta.url).href
        },
        component: () => import('@/components/Page/Service/ServiceIndex.vue')
      },
      {
        path: 'about',
        name: '회사소개',
        meta: { 
          title: '회사소개 | 디코나이',
          pageTitle: 'About Us',
          pageSubTitle: '혁신적인 아이디어로 변화를 주도합니다.',
          backgroundImage: new URL('@/assets/img/sub_top2.jpg', import.meta.url).href
        },
        component: () => import('@/components/Page/About/AboutIndex.vue')
      },
      {
        path: 'news',
        name: '회사소식',
        meta: { 
          title: '회사소식 | 디코나이',
          pageTitle: 'STORY',
          pageSubTitle: '디코나이의 소식을 가장 먼저 만나보세요.',
          backgroundImage: new URL('@/assets/img/sub_top3.jpg', import.meta.url).href
        },
        component: () => import('@/components/Page/News/NewsIndex.vue'),
        children: [
          {
            path: '',  
            name: '회사소식-리스트',
            component: () => import('@/components/Page/News/BoardList.vue')
          },
          {
            path: 'view/:boardId',
            name: '회사소식-상세보기',
            component: () => import('@/components/Page/News/BoardView.vue')
          }
          // {
          //   path: 'view',
          //   name: '회사소식-상세보기',
          //   component: () => import('@/components/Page/News/BoardView.vue')
          // }
        ]
      },
      {
        path: 'contact',
        name: '문의하기',
        meta: { 
          title: '문의하기 | 디코나이',
          pageTitle: 'Contact Us',
          pageSubTitle: '우리의 만남이 무한한 가능성을 엽니다.',
          backgroundImage: new URL('@/assets/img/sub_top4.jpg', import.meta.url).href
        },
        component: () => import('@/components/Page/Contact/ContactIndex.vue')
      },
    ]
  },
  {
    path: '/admin',
    redirect: { name: 'Admin Login' },
    name: 'AdminView',
    component: () => import('@/views/AdminView.vue'),
    children: [
      {
        path: 'login',
        name: 'Admin Login',
        meta: { title: '로그인 | 디코나이 관리자' },
        component: () => import('@/components/Admin/LoginComp.vue')
      },
      {
        path: 'entry',
        name: '관리자 메인',
        meta: { title: '디코나이 관리자' },
        component: () => import('@/components/Admin/AdminIndex.vue')
      },
      {
        path: 'module',
        name: '관리자 서브페이지',
        component: () => import('@/components/Admin/Page/PageIndex.vue'),
        children: [
          {
            path: 'board',
            name: '관리자 게시판',
            meta: { title: '게시판 | 디코나이 관리자' },
            component: () => import('@/components/Admin/Page/Board/BoardIndex.vue'),
            children: [
              {
                path: 'list',                
                component: () => import('@/components/Admin/Page/Board/BoardList.vue'),
              },
              {
                path: 'detail/:newsId',
                component: () => import('@/components/Admin/Page/Board/BoardDetail.vue'),
              },
              {
                path: 'write',
                component: () => import('@/components/Admin/Page/Board/BoardWrite.vue'),
              },
            ],
          },
          {
            path: 'inquiry',
            name: '관리자 문의사항',
            meta: { title: '문의사항 | 디코나이 관리자' },
            component: () => import('@/components/Admin/Page/Inquiry/InquiryIndex.vue'),
            children: [
              {
                path: 'list',                
                component: () => import('@/components/Admin/Page/Inquiry/InquiryList.vue'),
              },
              {
                path: 'detail/:contactId',
                component: () => import('@/components/Admin/Page/Inquiry/InquiryDetail.vue'),
              }
            ],
          },
          {
            path: 'apply',
            name: '관리자 입사지원',
            meta: { title: '입사지원 | 디코나이 관리자' },
            component: () => import('@/components/Admin/Page/Apply/ApplyIndex.vue'),
            children: [
              {
                path: 'list',                
                component: () => import('@/components/Admin/Page/Apply/ApplyList.vue'),
              },
              {
                path: 'detail/:applyId',
                component: () => import('@/components/Admin/Page/Apply/ApplyDetail.vue'),
              }
            ],
          },
        ]
      },
    ],
  },  
]

const router = createRouter({
  history: createWebHistory(),
  routes,  
})

router.beforeEach((to, from, next) => {
  if (to.fullPath !== window.location.pathname) {
    window.location.href = to.fullPath;
  } else {
    next();
  }
});

export default router